import React from 'react';
import { IconCustom } from '@jira/platform__icon-custom/src/IconCustom.tsx';
import DefaultAppIcon from '@atlaskit/icon/core/app';
import { token } from '@atlaskit/tokens';

type AppIconProps = {
	iconUrl: string;
	shouldChangeFillColor?: boolean;
};

export function AppIcon({ iconUrl, shouldChangeFillColor }: AppIconProps): React.JSX.Element {
	return iconUrl.trim().length > 0 ? (
		<IconCustom url={iconUrl} shouldChangeFillColor={shouldChangeFillColor} />
	) : (
		<DefaultAppIcon label="" color={token('color.icon')} />
	);
}
